<template>
  <Layout title="Home">
    <div class="d-flex flex-column flex-grow-1">
      <div class="bg-bridge bg-light pt-5">
        <div class="container pt-5">
          <div class="row justify-content-center pt-5">
            <div class="col-12 pt-5">
              <h1 class="text-center text-white mt-5 mb-4 pt-5">
                {{ welcomeMessage }}
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showActions" class="options">
        <div class="container">
          <div class="row">
            <div class="col-12 mb-5">
              <h1>What would you like to do today?</h1>
            </div>
          </div>
        </div>

        <!-- Terms -->
        <div
          class="container mb-5"
          v-if="$page.props.auth.user.organisation.name === 'Clausify Limited'"
        >
          <h3 class="text-primary font-weight-bold mb-4">
            Create a Clausify Client
          </h3>
          <div class="row">
            <div
              class="col-6 d-flex flex-column"
              v-if="assetTypes.includes('clausify-use-terms')"
            >
              <div class="option">
                <InertiaLink
                  disabled
                  :href="
                    assetTypes.includes('clausify-use-terms')
                      ? route('asset.create', 'clausify-use-terms')
                      : route('home')
                  "
                  class="card bg-light text-center"
                >
                  <div class="card-body">
                    <Icon
                      :icon="
                        allAssetTypes.find(
                          assetType => assetType.slug === 'clausify-use-terms'
                        ).meta.icon
                      "
                      :width="50"
                      colour="#6666ff"
                      class="mb-2"
                    />
                    <p>
                      {{
                        allAssetTypes.find(
                          assetType => assetType.slug === "clausify-use-terms"
                        ).meta.homepage.title
                      }}
                    </p>
                  </div>
                </InertiaLink>
              </div>
              <p class="mt-2 text-center text-muted">
                {{
                  allAssetTypes.find(
                    assetType => assetType.slug === "clausify-use-terms"
                  ).meta.homepage.intro
                }}
              </p>
            </div>
          </div>
        </div>

        <!-- NDA -->
        <div class="container mb-5">
          <h3 class="text-primary font-weight-bold mb-4">
            Non-Disclosure Agreement (NDA)
          </h3>
          <div class="row">
            <div
              class="col-6 d-flex flex-column"
              v-if="assetTypes.includes('one-nda')"
            >
              <div class="option flex-grow-1">
                <InertiaLink
                  :href="
                    assetTypes.includes('one-nda')
                      ? route('asset.create', 'one-nda')
                      : route('home')
                  "
                  class="card bg-light text-center"
                >
                  <div class="card-body">
                    <Icon
                      :icon="
                        allAssetTypes.find(
                          assetType => assetType.slug === 'one-nda'
                        ).meta.icon
                      "
                      :width="50"
                      colour="#6666ff"
                      class="mb-2"
                    />
                    <p>
                      {{
                        allAssetTypes.find(
                          assetType => assetType.slug === "one-nda"
                        ).meta.homepage.title
                      }}
                    </p>
                  </div>
                </InertiaLink>
              </div>
              <p class="mt-2 text-center text-muted">
                {{
                  allAssetTypes.find(assetType => assetType.slug === "one-nda")
                    .meta.homepage.intro
                }}
              </p>
            </div>
            <div
              class="col-6 d-flex flex-column"
              v-if="assetTypes.includes('non-disclosure-agreement')"
            >
              <div class="option flex-grow-1">
                <InertiaLink
                  :href="
                    assetTypes.includes('non-disclosure-agreement')
                      ? route('asset.create', 'non-disclosure-agreement')
                      : route('home')
                  "
                  class="card bg-light text-center"
                >
                  <div class="card-body">
                    <Icon
                      :icon="
                        allAssetTypes.find(
                          assetType =>
                            assetType.slug === 'non-disclosure-agreement'
                        ).meta.icon
                      "
                      :width="50"
                      colour="#6666ff"
                      class="mb-2"
                    />
                    <p>
                      {{
                        allAssetTypes.find(
                          assetType =>
                            assetType.slug === "non-disclosure-agreement"
                        ).meta.homepage.title
                      }}
                    </p>
                  </div>
                </InertiaLink>
              </div>
              <p class="mt-2 text-center text-muted">
                {{
                  allAssetTypes.find(
                    assetType => assetType.slug === "non-disclosure-agreement"
                  ).meta.homepage.intro
                }}
              </p>
            </div>
          </div>
        </div>

        <!-- Frameworks -->
        <div class="container mb-5">
          <h3 class="text-primary font-weight-bold mb-4">
            Digital & Consulting Agreement Suite
          </h3>
          <div class="row">
            <div
              class="col d-flex flex-column"
              v-if="assetTypes.includes('framework-agreement')"
            >
              <div class="option flex-grow-1">
                <InertiaLink
                  :href="
                    assetTypes.includes('framework-agreement')
                      ? route('asset.create', 'framework-agreement')
                      : route('home')
                  "
                  class="card bg-light text-center"
                >
                  <div class="card-body">
                    <Icon
                      :icon="
                        allAssetTypes.find(
                          assetType => assetType.slug === 'framework-agreement'
                        ).meta.icon
                      "
                      :width="50"
                      colour="#6666ff"
                      class="mb-2"
                    />
                    <p>
                      {{
                        allAssetTypes.find(
                          assetType => assetType.slug === "framework-agreement"
                        ).meta.homepage.title
                      }}
                    </p>
                  </div>
                </InertiaLink>
              </div>
              <p class="mt-2 text-center text-muted">
                {{
                  allAssetTypes.find(
                    assetType => assetType.slug === "framework-agreement"
                  ).meta.homepage.intro
                }}
              </p>
            </div>
            <div
              class="col d-flex flex-column"
              v-if="assetTypes.includes('framework-agreement-sow')"
            >
              <div class="option flex-grow-1">
                <InertiaLink
                  :href="
                    assetTypes.includes('framework-agreement-sow')
                      ? route('asset.create', 'framework-agreement-sow')
                      : route('home')
                  "
                  class="card bg-light text-center"
                >
                  <div class="card-body">
                    <Icon
                      :icon="
                        allAssetTypes.find(
                          assetType =>
                            assetType.slug === 'framework-agreement-sow'
                        ).meta.icon
                      "
                      :width="50"
                      colour="#6666ff"
                      class="mb-2"
                    />
                    <p>
                      {{
                        allAssetTypes.find(
                          assetType =>
                            assetType.slug === "framework-agreement-sow"
                        ).meta.homepage.title
                      }}
                    </p>
                  </div>
                </InertiaLink>
              </div>
              <p class="mt-2 text-center text-muted">
                {{
                  allAssetTypes.find(
                    assetType => assetType.slug === "framework-agreement-sow"
                  ).meta.homepage.intro
                }}
              </p>
            </div>
            <div
              class="col d-flex flex-column"
              v-if="hasFrameworkSuiteDocuments"
            >
              <div class="option flex-grow-1">
                <InertiaLink
                  :href="
                    hasFrameworkSuiteDocuments
                      ? route('asset.create', 'change-request')
                      : route('home')
                  "
                  class="card bg-light text-center"
                >
                  <div class="card-body">
                    <Icon
                      :icon="
                        allAssetTypes.find(
                          assetType => assetType.slug === 'change-request'
                        ).meta.icon
                      "
                      :width="50"
                      colour="#6666ff"
                      class="mb-2"
                    />
                    <p>
                      {{
                        allAssetTypes.find(
                          assetType => assetType.slug === "change-request"
                        ).meta.homepage.title
                      }}
                    </p>
                  </div>
                </InertiaLink>
              </div>
              <p class="mt-2 text-center text-muted">
                {{
                  allAssetTypes.find(
                    assetType => assetType.slug === "change-request"
                  ).meta.homepage.intro
                }}
              </p>
            </div>
          </div>
        </div>

        <!-- Standard Documents -->
        <div class="container mb-5">
          <h3
            v-if="
              (userHasPermissionTo('create_msa') &&
                assetTypes.includes('master-service-agreement')) ||
                (userHasPermissionTo('create_wc') &&
                  assetTypes.includes('work-category')) ||
                (userHasPermissionTo('create_sow') &&
                  assetTypes.includes('statement-of-work')) ||
                (userHasPermissionTo('create_cr') && hasMsaSuiteDocuments)
            "
            class="text-primary font-weight-bold mb-4"
          >
            Master Agreement Suite
          </h3>
          <div class="row">
            <div
              v-if="
                userHasPermissionTo('create_msa') &&
                  assetTypes.includes('master-service-agreement')
              "
              class="col d-flex flex-column"
            >
              <div class="option flex-grow-1">
                <InertiaLink
                  :href="
                    assetTypes.includes('master-service-agreement')
                      ? route('asset.create', 'master-service-agreement')
                      : route('home')
                  "
                  class="card bg-light text-center"
                >
                  <div class="card-body">
                    <Icon
                      :icon="
                        allAssetTypes.find(
                          assetType =>
                            assetType.slug === 'master-service-agreement'
                        ).meta.icon
                      "
                      :width="50"
                      colour="#6666ff"
                      class="mb-2"
                    />
                    <p>
                      {{
                        allAssetTypes.find(
                          assetType =>
                            assetType.slug === "master-service-agreement"
                        ).meta.homepage.title
                      }}
                    </p>
                  </div>
                </InertiaLink>
              </div>
              <p class="mt-2 text-center text-muted">
                {{
                  allAssetTypes.find(
                    assetType => assetType.slug === "master-service-agreement"
                  ).meta.homepage.intro
                }}
              </p>
            </div>
            <div
              v-if="
                userHasPermissionTo('create_wc') &&
                  assetTypes.includes('work-category')
              "
              class="col d-flex flex-column"
            >
              <div class="option flex-grow-1">
                <InertiaLink
                  :href="
                    assetTypes.includes('work-category')
                      ? route('asset.create', 'work-category')
                      : route('home')
                  "
                  class="card bg-light text-center"
                >
                  <div class="card-body">
                    <Icon
                      :icon="
                        allAssetTypes.find(
                          assetType => assetType.slug === 'work-category'
                        ).meta.icon
                      "
                      :width="50"
                      colour="#6666ff"
                      class="mb-2"
                    />
                    <p>
                      {{
                        allAssetTypes.find(
                          assetType => assetType.slug === "work-category"
                        ).meta.homepage.title
                      }}
                    </p>
                  </div>
                </InertiaLink>
              </div>
              <p class="mt-2 text-center text-muted">
                {{
                  allAssetTypes.find(
                    assetType => assetType.slug === "work-category"
                  ).meta.homepage.intro
                }}
              </p>
            </div>
            <div
              v-if="
                userHasPermissionTo('create_sow') &&
                  assetTypes.includes('statement-of-work')
              "
              class="col d-flex flex-column"
            >
              <div class="option flex-grow-1">
                <InertiaLink
                  :href="
                    assetTypes.includes('statement-of-work')
                      ? route('asset.create', 'statement-of-work')
                      : route('home')
                  "
                  class="card bg-light text-center"
                >
                  <div class="card-body">
                    <Icon
                      :icon="
                        allAssetTypes.find(
                          assetType => assetType.slug === 'statement-of-work'
                        ).meta.icon
                      "
                      :width="50"
                      colour="#6666ff"
                      class="mb-2"
                    />
                    <p>
                      {{
                        allAssetTypes.find(
                          assetType => assetType.slug === "statement-of-work"
                        ).meta.homepage.title
                      }}
                    </p>
                  </div>
                </InertiaLink>
              </div>
              <p class="mt-2 text-center text-muted">
                {{
                  allAssetTypes.find(
                    assetType => assetType.slug === "statement-of-work"
                  ).meta.homepage.intro
                }}
              </p>
            </div>
            <div
              v-if="userHasPermissionTo('create_cr') && hasMsaSuiteDocuments"
              class="col d-flex flex-column"
            >
              <div class="option flex-grow-1">
                <InertiaLink
                  :href="
                    hasMsaSuiteDocuments
                      ? route('asset.create', 'change-request')
                      : route('home')
                  "
                  class="card bg-light text-center"
                >
                  <div class="card-body">
                    <Icon
                      :icon="
                        allAssetTypes.find(
                          assetType => assetType.slug === 'change-request'
                        ).meta.icon
                      "
                      :width="50"
                      colour="#6666ff"
                      class="mb-2"
                    />
                    <p>
                      {{
                        allAssetTypes.find(
                          assetType => assetType.slug === "change-request"
                        ).meta.homepage.title
                      }}
                    </p>
                  </div>
                </InertiaLink>
              </div>
              <p class="mt-2 text-center text-muted">
                {{
                  allAssetTypes.find(
                    assetType => assetType.slug === "change-request"
                  ).meta.homepage.intro
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import helpers from "@/Mixins/helpers";
import Layout from "@/Shared/Layout";
import Icon from "@/Icons/Icon";

export default {
  mixins: [helpers],

  components: {
    Layout,
    Icon
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    assets: {
      type: [Object, Array],
      default: null
    },
    assetTypes: {
      type: Array,
      default: null
    },
    allAssetTypes: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      activeData: this.active,
      steps: [
        {
          url: "/demo/master-service-agreement",
          icon: "msa",
          title: "Step 1",
          copy: "Set up a Master Services Agreement"
        },
        {
          url: "",
          icon: "workcategory",
          title: "Step 2",
          copy: "Configure the relevent Work Category"
        },
        {
          url: "",
          icon: "sow",
          title: "Step 3",
          copy: "Create a new Statement of Work"
        }
      ]
    };
  },

  computed: {
    hasMsaSuiteDocuments() {
      // TODO: Create suites in the Database
      const msaSuiteDocumentSlugs = [
        "master-service-agreement",
        "statement-of-work",
        "work-category"
      ];

      const msaDocs = this.assetTypes.filter(assetType =>
        msaSuiteDocumentSlugs.includes(assetType)
      );
      return msaDocs.length > 0;
    },

    hasFrameworkSuiteDocuments() {
      // TODO: Create suites in the Database
      const frameworkSuiteDocumentSlugs = [
        "framework-agreement",
        "framework-agreement-sow"
      ];

      const frameworkDocs = this.assetTypes.filter(assetType =>
        frameworkSuiteDocumentSlugs.includes(assetType)
      );
      return frameworkDocs.length > 0;
    },

    showMsaChangeRequest() {
      return (
        this.hasMsaSuiteDocuments && this.assetTypes.includes("change-request")
      );
    },

    showFrameworkChangeRequest() {
      return (
        this.hasFrameworkSuiteDocuments &&
        this.assetTypes.includes("change-request")
      );
    },

    welcomeMessage() {
      return !this.active
        ? `Welcome to Clausify, ${this.$page.props.auth.user.first_name}`
        : `Welcome back, ${this.$page.props.auth.user.first_name}`;
    },

    showActions() {
      return (
        this.userHasPermissionTo("create_msa") ||
        this.userHasPermissionTo("create_wc") ||
        this.userHasPermissionTo("create_sow") ||
        this.userHasPermissionTo("create_cr")
      );
    }
  }
};
</script>
